(() => {
  if (window.terjungProductCardHintsReady) return;
  window.terjungProductCardHintsReady = true;
  window.terjungProductCardHintsVersion = '2026-06-03-toggle-v8';

  const selector = '[data-product-card-hint]';
  let lastOpenedAt = 0;
  let suppressNextClickFor = null;

  function closeHints(except) {
    document.querySelectorAll(selector + '[open]').forEach((hint) => {
      if (hint !== except) hint.removeAttribute('open');
    });
  }

  document.addEventListener('toggle', (event) => {
    const hint = event.target;
    if (!(hint instanceof HTMLDetailsElement) || !hint.matches(selector) || !hint.open) return;

    lastOpenedAt = Date.now();
    closeHints(hint);
  }, true);

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'mouse') return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    const summary = target.closest(selector + ' > summary');
    const hint = summary?.closest(selector);
    if (hint instanceof HTMLDetailsElement && hint.open) {
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressNextClickFor = hint;
      hint.removeAttribute('open');
    }
  }, true);

  document.addEventListener('touchstart', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const summary = target.closest(selector + ' > summary');
    const hint = summary?.closest(selector);
    if (hint instanceof HTMLDetailsElement && hint.open) {
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressNextClickFor = hint;
      hint.removeAttribute('open');
    }
  }, { capture: true, passive: false });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const summary = target.closest(selector + ' > summary');
    if (summary) {
      const hint = summary.closest(selector);
      if (hint instanceof HTMLDetailsElement) {
        if (hint === suppressNextClickFor) {
          event.preventDefault();
          event.stopImmediatePropagation();
          suppressNextClickFor = null;
          return;
        }
        const shouldClose = hint.open;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (shouldClose) {
          hint.removeAttribute('open');
          window.setTimeout(() => hint.removeAttribute('open'), 0);
        } else {
          closeHints(hint);
          hint.setAttribute('open', '');
          lastOpenedAt = Date.now();
        }
      }
      return;
    }
    if (!target.closest(selector)) closeHints();
  }, true);

  document.addEventListener('pointermove', (event) => {
    if (window.matchMedia?.('(hover: none)').matches) return;
    if (event.pointerType && event.pointerType !== 'mouse') return;
    const target = event.target;
    if (target instanceof Element && target.closest(selector)) return;
    if (Date.now() - lastOpenedAt > 220) closeHints();
  }, { passive: true });

  window.addEventListener('scroll', () => closeHints(), { capture: true, passive: true });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeHints();
  });
})();